import WhoWeAre from "./WhoWeAre";
import WhatWeDo from "./WhatWeDo"
import Contact from "./Contact" 
import Banner from "./Banner" 
import { Container, Row } from "react-bootstrap";
// import useFetch from "./useFetch";
import "../style/Home.css"

const Home = () => {

  return (
    <Container fluid>
      <Row>
        <Banner></Banner>
      </Row>
      <Row  className="Home subsection">
        <WhoWeAre></WhoWeAre>
      </Row>
      <Row className="Home subsection">
        <WhatWeDo></WhatWeDo>
      </Row>
      <Row className="Home">
        <Contact></Contact>
      </Row>
    </Container>
  );
}
 
export default Home;
